// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrExpenseFieldDto
 */
export interface IOcrExpenseFieldDto {
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    patient?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    service?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    amount?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    discount?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    expense?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    quantity?: string;
    /**
     * 
     * @type {string}
     * @memberof IOcrExpenseFieldDto
     */
    service_date?: string;
}

/**
 * Check if a given object implements the IOcrExpenseFieldDto interface.
 */
export function instanceOfIOcrExpenseFieldDto(value: object): value is IOcrExpenseFieldDto {
    return true;
}

export function IOcrExpenseFieldDtoFromJSON(json: any): IOcrExpenseFieldDto {
    return IOcrExpenseFieldDtoFromJSONTyped(json, false);
}

export function IOcrExpenseFieldDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrExpenseFieldDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': json['patient'] == null ? undefined : json['patient'],
        'service': json['service'] == null ? undefined : json['service'],
        'category': json['category'] == null ? undefined : json['category'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'discount': json['discount'] == null ? undefined : json['discount'],
        'expense': json['expense'] == null ? undefined : json['expense'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'service_date': json['service_date'] == null ? undefined : json['service_date'],
    };
}

export function IOcrExpenseFieldDtoToJSON(json: any): IOcrExpenseFieldDto {
    return IOcrExpenseFieldDtoToJSONTyped(json, false);
}

export function IOcrExpenseFieldDtoToJSONTyped(value?: IOcrExpenseFieldDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': value['patient'],
        'service': value['service'],
        'category': value['category'],
        'amount': value['amount'],
        'discount': value['discount'],
        'expense': value['expense'],
        'quantity': value['quantity'],
        'service_date': value['service_date'],
    };
}

